var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('stdDialog',{key:_vm.key,attrs:{"title":'選擇' + _vm.title,"visible":_vm.modalOpen,"modal-append-to-body":false,"top":"10vh","width":"100%"},on:{"update:visible":function($event){_vm.modalOpen=$event}}},[_c('div',{staticClass:"cascader-selector"},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }